/**
 * Helper module for parsing and storing User Agent data
 * @module
 */
var _ = require('optimizely-client-fn');
var detect = require('../lib/detect');
var WindowEnv = require('../env/window');

var actionTypes = require('../constants/action_types');
var di = require('../di');
var Flux = require('../flux');

var uaStore = di.get('stores/ua_data');

/**
 * Returns user agent data from store if available,
 * Else parses the UA to initialize store
 * @return {UserAgentData}
 */
exports.get = function(): UserAgentData {
  var uaData = uaStore.get();
  if (_.isEmpty(uaData)) {
    uaData = detect.parseUA(WindowEnv.getUserAgent());
    if (__INVARIANT__) {
      require('core/utils/invariant').isType('UserAgentData', uaData);
    }

    // dispatch
    Flux.dispatch(actionTypes.SET_UA_DATA, {
      data: uaData,
    });
  }

  return uaData;
};
